// extracted by mini-css-extract-plugin
module.exports = {"developConsole":"DevelopConsole_developConsole_3jq1P","developConsole__content":"DevelopConsole_developConsole__content_1MaZ7"};